/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useStore } from '../Context';
import { ERRORS, GESTURES, CAMERAS } from '../constants'
import Navigation from '../components/Navigation/Navigation';
import signs from '../services/signs'
import ImageTheme from '../components/Images/ImageThemed';
import loanlogs from '../services/loanlogs';
import cuotitasstores from '../services/cuotitasstores';
import moment from 'moment';
import { errorsKeys } from '../constants/errorTypes';

function SelfieSignature() {
    const { hash, openModal, photoUri, clearPhoto, setToken, loading, setLoading, setCamera, requestId, stepForward, stepBackwards, dni, setError } = useStore();
    const gesture = GESTURES[photoUri.randomSelfie]
    const from = moment().format('MM-DD-YYYY hh:mm:ss.SSSS A');
    
    async function handleSubmit () {
        try {
            if (!photoUri.specialSelfie) return;
        setLoading(true);

         //uploadS3
        const neutralFileUrl = await cuotitasstores.uploadS3({
            fileUri: photoUri.neutralSelfie,
            filename: `${hash}-${dni}-${from}-SN.jpg`,
            dirname: "selfie",
          });
        const smileFileUrl = await cuotitasstores.uploadS3({
            fileUri: photoUri.specialSelfie,
            filename: `${hash}-${dni}-${from}-${gesture.type}.jpg`,
            dirname: "selfie",
          });

        const allSelfies = {
            hash: hash,
            selfie1: neutralFileUrl,
            selfie2: smileFileUrl,
            type1: 'SN',
            type2: gesture.type
        }
        
        await signs.postSelfie(allSelfies, setToken, requestId)
        await signs.postDocument(photoUri, requestId)
            setLoading(false);
            stepForward();

        return;
        } catch (error) {
            const errorTypes = Object.values(errorsKeys).map(error => error.type).filter(e => e !== undefined);
            if (errorTypes.includes(error?.extra?.key)) {
                setError(error);
            }
            const operation = await signs.getUser();
            
            if (operation && operation.attempts === 0) {
                setError({
                    "error": "Cuotitas Request is cancelled.",
                    "extra": {
                        "key": "attempts_are_over"
                    }
                })
            }
            const message = ERRORS[error.code] || undefined
                setLoading(false);
                openModal({ type: 'retry', message });
                photoUri.neutralSelfie = null;
                photoUri.specialSelfie = null;
                stepBackwards();
        }
    };

    function handleRetakePhoto () {
        clearPhoto({ [CAMERAS.SELFIE_SPECIAL]: null });
        setCamera({ open: true, type: CAMERAS.SELFIE_SPECIAL });
    };

    function handleOpenCamera () {
        setCamera({ open: true, type: CAMERAS.SELFIE_SPECIAL });
    }

    useEffect(() => {
        loanlogs.success('/selfie/special', { response: { gesture } }).catch(console.log)
    }, []);

    return (
        <main className='page-step'>
            <Navigation />
            <header className="page-header">
                <h1>Firma electrónica</h1>
            </header>
            <div className='page-content frame' onClick={handleOpenCamera}>
                {photoUri.specialSelfie 
                    ? (<img className='frame-image' src={photoUri.specialSelfie} alt='' />) 
                    : (
                        <>
                            <ImageTheme src={`/selfie-${gesture.name}.svg`} alt="" width="250" />
                            <p className='text-center text-balance mx-1 pb-1'>
                                <strong>Presiona acá</strong> para tomar una <strong>{gesture.input}</strong>
                            </p>
                        </>
                    )
                }
            </div>
            <button className='button-primary' disabled={loading} onClick={handleSubmit}>
                Confirmar
            </button>
            <button className='button-secondary' onClick={handleRetakePhoto} disabled={loading}>
                Tomar otra fotografía
            </button>
        </main>
    );
}

export default SelfieSignature;
